"use strict";

var TF_SHIFT = 12;
var TOTFREQ = 1 << TF_SHIFT;
var RANS_BYTE_L = 1 << 23;
module.exports = {
  TF_SHIFT: TF_SHIFT,
  TOTFREQ: TOTFREQ,
  RANS_BYTE_L: RANS_BYTE_L
};